import { call, put, takeLatest } from 'redux-saga/effects';

import { promptToast } from '../../../../components/toast-container/actions';
import { VERIFY_EMAIL } from '../actions';
import { verifyEmail } from '../requests';

export function* handleVerifyEmail(action) {
  try {
    const response = yield call(
      verifyEmail,
      action.userId,
      action.email,
      action.token
    );

    if (response.errors) {
      throw new Error(response.errors[0].code);
    }

    yield put(
      promptToast(
        'success',
        window.APP_GLOBALS.t('account', 'confirm.email-confirmed')
      )
    );
  } catch (e) {
    yield put(
      promptToast(
        'success',
        window.APP_GLOBALS.t('errors', 'confirm.email-not-confirmed')
      )
    );
  }
}

function* mySaga() {
  yield takeLatest(VERIFY_EMAIL, handleVerifyEmail);
}

if (IS_BROWSER) {
  window.registerSaga(mySaga);
}

export default mySaga;
